import { bindActionCreators } from 'redux';
import { showMessage } from '../actions/show-message';

export default function createEnvironment(store) {
  return bindActionCreators({ showMessage }, store.dispatch);
}
